export const getProcessesList = (state) => state.processesList;

export const getProcessInspectorById = (state) => state.processInspectorById;
